import { useEffect } from "react";

export default function BaseRemover() {
  useEffect(() => {
    const baseElement = document.querySelector("base");
    if (!baseElement) return;
    document.head.removeChild(baseElement);
  }, []);
  return null;
}
